<template>
  <v-layout justify-center>
    <v-card width="80%" v-if="!loading && !failed">
      <v-card-title class="headline footer" primary-title>
        Order sizes
      </v-card-title>
      <v-card-text>
        <v-row class="my-4">
          <draggable v-model="sizes" class="row">
            <v-col cols="2" v-for="(item, i) in sizes" :key="i" class=".item">
              <v-card color="success">
                <v-card-text>
                  <h3 class="basic--text">{{ item }}</h3>
                </v-card-text>
              </v-card>
            </v-col>
          </draggable>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="error" outlined @click="goBack">
          <v-icon left color="error">mdi-arrow-left-bold</v-icon>
          Back
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          outlined
          color="success"
          @click="putOrderedSizes"
          :disabled="sizes.length == 0"
        >
          Continue <v-icon right>mdi-arrow-right-bold</v-icon></v-btn
        >
      </v-card-actions>
    </v-card>
    <v-card flat v-if="loading">
      <v-card-text>
        <v-row justify="center">
          <v-col cols="4">
            <v-progress-circular
              :size="70"
              color="accent"
              indeterminate
            ></v-progress-circular>
          </v-col>
        </v-row>
        <v-row justify="center">
          <h3 class="basic--text text-center">Loading sizes...</h3>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card flat v-if="failed" class="mt-10">
      <v-card-text>
        <v-row justify="center">
          <v-col cols="4">
            <v-img :src="require(`@/assets/${responseImg}`)"></v-img>
          </v-col>
        </v-row>
        <v-row justify="center" class="mt-10">
          <h2 class="red--text">{{ responseMessage }}</h2>
        </v-row>
        <v-row justify="center" class="mt-10">
          <v-btn outlined color="error" @click="goBack"
            ><v-icon left>mdi-arrow-left</v-icon> Back to start</v-btn
          >
        </v-row>
      </v-card-text>
    </v-card>
  </v-layout>
</template>
<script>
export default {
  name: "OrderSizes",
  props: {
    items: Array, //skuArray
  },
  data: () => ({
    sizes: [],
    loading: true,
    responseImg: "",
    failed: false,
    responseMessage: "",
  }),
  methods: {
    putOrderedSizes() {
      this.$emit("orderedSizes", this.sizes);
    },
    async getSizes() {
      let formData = new FormData();
      this.loading = true;
      for (let indx in this.items) {
        formData.append("products", JSON.stringify(this.items[indx]));
      }
      try {
        const response = await this.$store.dispatch("getSizes", formData);
        this.sizes = response.data;
        this.loading = false;
      } catch (error) {
        this.failed = true;
        this.loading = false;
        //if received response
        if (error.response) {
          this.showErrors(error.response.status, error.response.data);
        } else {
          // anything else
          this.responseImg = "feeling_blue.svg";
          this.responseMessage =
            "SORRY... Something went wrong. Did not get any response.";
        }
      }
    },
    goBack() {
      this.$emit("backToFilter");
    },
    showErrors(status, message) {
      // client received an error response (5xx, 4xx)
      this.responseMessage = `${message} [${status}]`;
      switch (status) {
        case 400:
          this.responseImg = "empty.svg";
          break;
        case 401:
          //clear local storage, push to login
          localStorage.clear();
          this.$router.push("login");
          break;
        case 403:
          this.responseImg = "403_forbidden.svg";
          break;
        case 404:
          this.responseImg = "void.svg";
          break;
        case 500:
          this.responseImg = "server_down.svg";
      }
    },
  },
  mounted() {
    this.getSizes();
  },
};
</script>

<style scoped>
.v-col {
  cursor: move;
}
</style>
